var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/viewmodels/placeholder',["require", "exports", "common/viewmodelbase"], function (require, exports, ViewModel) {
    "use strict";
    var PlaceholderViewModel = (function (_super) {
        __extends(PlaceholderViewModel, _super);
        //#region ctor
        function PlaceholderViewModel() {
            _super.call(this);
            this.knowledgeBaseUrl = 'https://www.cch.co.uk/softwaresupport/2015/resources/knowledgebase.asp';
            this.title = $.t("app:modules.home.headline_title", { ifMissing: "home" });
        }
        //#endregion
        PlaceholderViewModel.prototype.onActivated = function (context) {
            return Q(true);
        };
        return PlaceholderViewModel;
    }(ViewModel.ViewModelBase));
    var instance = new PlaceholderViewModel();
    return instance;
});

